import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';

import CommonModal from '../common-modal/CommonModal';
import FilterSection from './filter-section/FilterSection';
import TooltipButton from '../tooltip-button/TooltipButton';
import Icon from '../../icons/Icon';

import scss from './CommonFiltersModal.module.scss';

function CommonFiltersModal({
  isOpen,
  onClose,
  selectedFilters,
  filters,
  onSelect,
  isApplyOnClose,
  AdditionalFilters,
}) {
  const { t } = useTranslation();

  const [localSelectedFilters, setLocalSelectedFilters] = useState({});

  const handleSelect = ({ groupName, option }) => {
    const { value, isRadio } = option;

    if (!value) {
      setLocalSelectedFilters((prevState) => {
        const { [groupName]: _, ...rest } = prevState;
        return rest;
      });
      return;
    }

    setLocalSelectedFilters((prevState) => {
      const groupItems = prevState?.[groupName] || [];

      let newState = { ...prevState };

      if (!groupItems.length || isRadio) {
        newState[groupName] = [option];
        return newState;
      }

      const isContained = groupItems.some((item) => item.value === option.value);

      if (isContained) {
        newState[groupName] = groupItems.filter((item) => item.value !== option.value);
        return newState;
      }

      const filteredGroupItems = groupItems.filter((item) => !item.isRadio);
      newState[groupName] = [...filteredGroupItems, option];

      return newState;
    });
  };

  const handleApply = () => {
    onSelect(localSelectedFilters);
    onClose();
  };

  const handleClose = () => {
    if (isApplyOnClose) {
      onSelect(localSelectedFilters);
    }
    onClose();
  };

  useEffect(() => {
    setLocalSelectedFilters(selectedFilters);
  }, [selectedFilters, isOpen]);

  return (
    <CommonModal isOpen={isOpen} onClose={onClose} isAnimated>
      <div className={scss.modalContent}>
        <h3 className={scss.title}>
          <Icon icon={FilterAltOutlinedIcon} />
          {t('filters')}
        </h3>

        <div className={scss.filtersGrid}>
          {filters.map((filter) => (
            <FilterSection
              key={filter.groupName}
              filters={filter}
              selectedFilters={localSelectedFilters}
              onSelect={handleSelect}
            />
          ))}
        </div>
        {AdditionalFilters ? (
          <AdditionalFilters
            localSelectedFilters={localSelectedFilters}
            onChangeLocalSelectedFilters={setLocalSelectedFilters}
          />
        ) : null}
        {!isApplyOnClose ? (
          <div className={scss.actions}>
            <TooltipButton type='button' styleColor='secondary' maxWidth={90} onClick={handleClose}>
              {t('cancel')}
            </TooltipButton>
            <TooltipButton type='button' styleColor='primary' maxWidth={90} onClick={handleApply}>
              {t('apply')}
            </TooltipButton>
          </div>
        ) : null}
      </div>
    </CommonModal>
  );
}

export default CommonFiltersModal;
